import { getVersion, getHost } from '../helper/utils';
import { filterConfigExtraValues } from '../helper/utils/common';
import { CONFIG_URL } from '../config';
import { sendRequest } from '../helper/utils/request';
import { mobileReport } from '../platform';
import { isCanUseH5DeviceSdkBridge } from '../plugins/useH5SdkBridge';
import { getUserAgent } from '../helper/utils/device';
/**
 * 统一上报设备信息方法
 * @param {object} config
 * @param {object} deviceValues
 * @param {object} nativeFingerprintResponse
 * @param {object} positionResponse
 */

export var request = function request(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$uploadConfig = _ref.uploadConfig,
      uploadConfig = _ref$uploadConfig === void 0 ? {} : _ref$uploadConfig,
      _ref$deviceValues = _ref.deviceValues,
      deviceValues = _ref$deviceValues === void 0 ? {} : _ref$deviceValues;
  //手机端上报jsbrige信息 pc端仅传位置信息
  // if (getUserAgent() !== 'Windows' && isCanUseH5DeviceSdkBridge()) {
  //   mobileReport({ config, data: nativeFingerprintResponse })
  // } else {
  // sendRequest({
  //   url: config.url || getHost(config) + CONFIG_URL.URL_DEVICE_LOCATION,
  //   params: {
  //     // ...filterConfigExtraValues(config, true),
  //     uuid: deviceValues.uuid || '',
  //     sv: deviceValues.sdk_version,
  //     ai: '001', //app_id
  //     li: positionResponse || '', //location_info
  //     ts: new Date().getTime() || '', //post_timestamp
  //   },
  // })
  // }
  //web设备信息
  sendRequest({
    url: uploadConfig.url || config.url || getHost(config) + CONFIG_URL.URL_FINGERPRINT,
    params: deviceValues
  });
};